export default __webpack_public_path__ + "static/media/chapter.e7450c8f.jpg";